export default __webpack_public_path__ + "static/media/sky-blue.c1ca59a2.svg";